import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { pdfFragment } from 'bundles/ent-website/queries/common';

export const entWebsitePdfViewerFragment = contentfulGql`#graphql
  ${pdfFragment}
  fragment EntWebsitePdfViewer on EntWebsitePdfViewer {
    slug
    fileAttachment {
      ...Pdf
    }
  }
`;

export const entWebsiteBlockPdfViewerQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsitePdfViewerFragment}

  query entWebsiteBlockPdfViewer($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsitePdfViewer
      }
    }
  }
`;
